import SEOMeta from '@/components/feature/SEOMeta';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import HotLinks from './components/HotLinks';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';

const homepageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '爱情岛论坛导航',
  url: 'https://aiqingdao-navigation.com/',
  description: '爱情岛论坛导航为您汇聚最新、最全的爱情岛论坛入口链接，提供一站式导航服务，快速找到官方地址、备用线路及相关社区资源，收藏本页永不迷路，随时畅享爱情岛论坛精彩内容。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://aiqingdao-navigation.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '爱情岛论坛导航是什么？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '爱情岛论坛导航是一个第三方导航聚合网站，专门为用户收集和整理爱情岛论坛的所有可用入口链接，包括官方地址、备用线路、社区资源等。',
      },
    },
    {
      '@type': 'Question',
      name: '这里提供的链接是否安全可靠？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '我们提供的所有链接都经过人工验证，确保指向的是爱情岛论坛的官方或授权入口。我们会持续监控各链接的可用性状态，并及时更新。',
      },
    },
    {
      '@type': 'Question',
      name: '如果某个链接打不开怎么办？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '当某个链接无法访问时，您可以尝试我们提供的备用线路。我们有多个不同网络运营商优化的备用入口，通常情况下至少有一条线路是可用的。',
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <SEOMeta
        title="爱情岛论坛导航 - 最全入口聚合导航站"
        description="爱情岛论坛导航为您汇聚最新、最全的爱情岛论坛入口链接，提供一站式导航服务，快速找到官方地址、备用线路及相关社区资源，收藏本页永不迷路，随时畅享爱情岛论坛精彩内容。"
        keywords="爱情岛论坛导航,爱情岛论坛入口,爱情岛论坛最新地址,爱情岛论坛备用线路,爱情岛论坛官网,爱情岛导航聚合,论坛导航大全"
        canonicalUrl="https://aiqingdao-navigation.com/"
        ogType="website"
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homepageSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />

      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <HotLinks />
        <LatestArticles />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}